/*
*初始化 web 统计
* */
import { BOM } from './BOM';
import { isNative } from './utils';
import { Tracker } from './Tracker';

export const init = async (event, label, params = {}) => {
    if (!BOM.window.trackerWeb && !isNative()) {
        BOM.window.trackerWeb = new Tracker(event, label, params);
    }
};
export const track =async (arg1, arg2, arg3) => {
    if (BOM.window.trackerWeb) {
        await BOM.window.trackerWeb.track(arg1, arg2, arg3);
    } else {
        BOM.log('trackerWeb not created');
    }
};

export const trackWebBeacon = (arg1, arg2, arg3)=> {
    if (BOM.window.trackerWeb) {
        BOM.window.trackerWeb.trackBeacon(arg1, arg2, arg3);
    } else {
        BOM.log('trackerWeb not created');
    }
}

export const trackTalkingData = (arg1, arg2, arg3)=> {
    if (BOM.window.trackerWeb) {
        BOM.window.trackerWeb.trackTalkingData(arg1, arg2, arg3);
    } else {
        BOM.log('trackerWeb not created');
    }
}
